import { CustomTip } from 'components/atoms/tooltipCustom'
import { ContactsTable, StackIcon } from 'shared/ui'

import type { ActionWithId } from '../../types'

export function LinkedLink({ enabled, hint, id }: ActionWithId) {
	return (
		<CustomTip arrow title={hint}>
			<a
				className={ContactsTable.css.cellAction}
				href={enabled ? `https://www.linkedin.com/in/${id}/` : undefined}
				rel='noopener noreferrer'
				target='_blank'
			>
				<StackIcon icon='linked' width={18} />
			</a>
		</CustomTip>
	)
}
